const text =
  '# Sample blog post This blog post shows a few different types of content that are supported and styled with Material styles. <br/>Basic typography, images, and code are all supported.<br/>You can extend these by modifying';

const fPost1 = {
  _id: 1,
  name: 'Olivier',
  postTitle: 'Sample blog post',
  postBody:
    '### Sample blog post This blog post shows a few different types of content that are supported and styled with Material styles.\n\n ### Basic typography, images, and code are all supported.You can extend these by modifying',
  date: '2020-06-01T16:03:24.804+00:00',
  imgIndex: 436,
};
const fPost2 = {
  _id: 2,
  name: 'Olivier',
  postTitle: 'Sample blog post',
  postBody:
    '### Sample blog post This blog post shows a few different types of content that are supported and styled with Material styles.\n #### Basic typography, images, and code are all supported.You can extend these by modifying',
  date: '2020-06-01T16:03:24.804+00:00',
  imgIndex: 575,
};
export { fPost1, fPost2 };
